export default __webpack_public_path__ + "media/color/ont-1e16c71a.svg";